var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { baseImgURL } from "../../network/api-config";
import { Carousel } from "../_common/carousel/carousel";
import LoadingBar from "../_common/loadingBar/loadingBar";
import { ModalWindowWrapper } from "../_common/modalWindow/modalWindow";
import { SelectedImg, ImageSpanName, CarouselBdpContent } from "./carouselBdps.styles";
import { ImageSet } from "./imageSet";
export var CarouselBdps = function (_a) {
    var lang = _a.lang, showCarouselBdps = _a.showCarouselBdps, setShowCarouselBdps = _a.setShowCarouselBdps, selectedImageIndex = _a.selectedImageIndex, thumbs = _a.thumbs;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), srcLeftPhoto = _c[0], setSrcLeftPhoto = _c[1];
    var handleSrcLeftPhoto = function (src) {
        setSrcLeftPhoto(src);
    };
    useEffect(function () {
        setLoading(true);
    }, [thumbs]);
    var handleImageLoad = function () {
        setLoading(false);
    };
    return (_jsx(ModalWindowWrapper, __assign({ widthContent: "90%", heightContent: "900px", maxWidthContent: "925px", lang: lang, isOpen: showCarouselBdps, onClose: function () { return setShowCarouselBdps(false); } }, { children: _jsx(Carousel, __assign({ selectedImage: selectedImageIndex, thumbs: thumbs.map(function (thumb) { return "".concat(baseImgURL, "/").concat(thumb.image); }), onChange: function () { return setSrcLeftPhoto(null); } }, { children: thumbs.map(function (thumb, index) {
                var _a, _b;
                return (_jsxs(CarouselBdpContent, { children: [((_a = thumb === null || thumb === void 0 ? void 0 : thumb.showroom) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
                            _jsx(ImageSet, { images: ((_b = thumb === null || thumb === void 0 ? void 0 : thumb.showroom) === null || _b === void 0 ? void 0 : _b.length) > 0 ? thumb === null || thumb === void 0 ? void 0 : thumb.showroom : null, srcLeftPhoto: srcLeftPhoto, handleSrcLeftPhoto: handleSrcLeftPhoto }) : null, _jsxs("div", { children: [loading && _jsx(LoadingBar, { isLoading: loading, isShowMsg: false }), _jsx(SelectedImg, { "$isActive": (thumb === null || thumb === void 0 ? void 0 : thumb.name) === 'UPLOADED' || (thumb === null || thumb === void 0 ? void 0 : thumb.name) === 'IN PROGRESS', src: srcLeftPhoto ? srcLeftPhoto : "".concat(baseImgURL, "/").concat(thumb === null || thumb === void 0 ? void 0 : thumb.image), onLoad: handleImageLoad }), (thumb === null || thumb === void 0 ? void 0 : thumb.name) ? (_jsx(ImageSpanName, __assign({ "$backdropsSelected": false }, { children: thumb === null || thumb === void 0 ? void 0 : thumb.name }))) : null
                                // <ImageSpanName $backdropsSelected={false}>
                                //   <LangMessage msgKey="CustDashboard.inProgress" />
                                // </ImageSpanName>
                            ] })] }, index));
            }) })) })));
};
